import React from 'react';
import WhatsappBlockListService from '../../../services';
import { toast } from 'react-toastify';
import { defaultImportFields } from 'components/ImportData/data/fields';
import ImportDataForm from 'components/ImportData';
import { useImportBlockList } from 'components/ImportData/hooks/useImportWhatsappBlockList';

/**
 * Modal para gerenciar a importação de números para a lista de bloqueio do WhatsApp.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Controla se o modal está visível
 * @param {Function} props.setIsOpen - Função para alternar a visibilidade do modal
 * @param {Function} props.onSuccess - Callback opcional para executar após sucesso
 */
const ImportBlockedWhatsappNumbersModal = ({
  isOpen,
  setIsOpen,
  onSuccess
}) => {
  const { validateBlockListData } = useImportBlockList();

  const handleSuccess = () => {
    toast.success(`Números importados para a lista de bloqueio.`);
    if (onSuccess) {
      onSuccess();
    }
  };

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      type="whatsAppBlockList"
      importService={WhatsappBlockListService.importWhatsappBlockList}
      defaultFields={defaultImportFields.WHATS_APP_BLOCKED_NUMBERS}
      validateData={validateBlockListData}
      onImportSuccess={handleSuccess}
    />
  );
};

export default ImportBlockedWhatsappNumbersModal;
